module.exports = __webpack_public_path__ + "static/media/logo_vrb.f9d2c9bd.svg";